"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
// tslint:disable-next-line: arrow-return-shorthand
exports.badgeTheme = function (theme) {
    var componentTheme = {
        /* background color of the box */
        background: {
            greyscale: theme.greyLight.color.normal,
            primary: theme.primary.color.normal,
            sale: theme.error.color.normal,
            success: theme.success.color.normal,
            warning: theme.warning.color.normal,
        },
        /* border of the badge; defaults to transparent */
        border: {
            greyscale: '1px solid transparent',
            primary: '1px solid transparent',
            sale: '1px solid transparent',
            success: '1px solid transparent',
            warning: '1px solid transparent',
        },
        /* border-radius for regluar label; pill border-radius = height */
        borderRadius: '0',
        /* font-size scales the badge; padding & height are also defined in `em` */
        fontSize: {
            small: '0.75em',
            medium: '1em',
            large: '1.25em',
        },
        /* text color */
        text: {
            greyscale: theme.greyLight.color.text,
            primary: theme.primary.color.text,
            sale: theme.error.color.text,
            success: theme.success.color.text,
            warning: theme.warning.color.text,
        },
    };
    if (theme.component.badge) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.badge);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { badge: componentTheme }) });
};
exports.default = exports.badgeTheme;
//# sourceMappingURL=theme.js.map